module.exports = __webpack_public_path__ + "img/Icons-18.f51751bf.svg";